import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/builds/jsws/jsws2/jsws_2_frontend/src/app/[[...slug]]/client.jsx");
